export default "/_next/static/images/1cc143d14d943bbf22cab8678b0712a5.jpg";